import type React from 'react';
import styled from 'styled-components';
import { Slideout } from '@makemydeal/ui-bricks/dist/cox';
import type { SlideoutProps } from '@makemydeal/dr-ui-bricks-types';

// cox's published SlideoutProps omit `children`, but at runtime the component renders them.
// styled(Slideout) inherits that props type, so re-type the wrapper to accept children.
export const StyledSlideout = styled(Slideout)`
    position: fixed;
    inset: 0px;
    z-index: 1200;

    .dr-slideout-backdrop {
        opacity: 1;
        background-color: color-mix(in srgb, rgb(74, 74, 74) 80%, transparent);
        transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1);
    }

    .dr-slideout-heading {
        padding: 20px 16px 16px 23px;

        h3 {
            font-size: 20px;
            font-weight: 600;
            line-height: 120%;
            margin: 0;
        }
        a {
            display: flex;
            justify-content: center;
            align-items: center;
            min-width: 32px;
            min-height: 32px;

            svg {
                width: 1em;
                height: 1em;
                font-size: 20px;
                color: rgb(90, 90, 90);
            }
        }
    }
` as unknown as React.FC<SlideoutProps>;
